import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import {
  Select as SelectCore,
  SelectInput,
  SelectList,
  SelectOption
} from 'aquilla/core/molecules/Select';

interface ClassTypeOption {
  id: string | number | null;
  content: string;
}

interface ClassTypeDropdownProps {
  options: ClassTypeOption[];
  selectedClassType: string | number | null;
  onSelect: (id: string | number | null) => void;
}

interface StyledSelectInputProps {
  $active: boolean;
}

const StyledSelectInput = styled(SelectInput)<StyledSelectInputProps>`
  padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B} ${Spacings.SPACING_2B}
    ${Spacings.SPACING_4B};

  border: ${({ $active }) =>
    $active
      ? `${Spacings.SPACING_1} solid var(--color-base-fill)`
      : `${Spacings.SPACING_1} solid var(--color-i-divider)`};

  min-height: ${Spacings.SPACING_10B};

  gap: ${Spacings.SPACING_3B};

  border-radius: 24px;

  span {
    font-weight: ${({ $active }) => ($active ? Fonts.SEMIBOLD : Fonts.LIGHT)};

    font-size: ${Fonts.H6};
  }

  svg {
    color: var(--color-text-primary);
  }
`;

const StyledSelectionList = styled(SelectList)`
  position: absolute;

  overflow-y: scroll !important;

  margin-top: 8px;

  z-index: 2;

  top: auto !important;

  min-width: max-content;

  white-space: nowrap;

  max-height: 40vh;

  scrollbar-width: none;

  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const ClassTypeDropdown = ({
  options,
  selectedClassType,
  onSelect
}: ClassTypeDropdownProps) => {
  const isActive = selectedClassType != null;

  const selectedLabel =
    selectedClassType == null
      ? 'Classes'
      : options.find((o) => o.id === selectedClassType)?.content || 'Classes';

  const getOptionValue = (option: ClassTypeOption): string =>
    option.id == null ? 'Classes' : option.content;

  const handleDesktopSelect = (value?: string) => {
    if (value) {
      const option = options.find((o) => getOptionValue(o) === value);

      if (option) {
        onSelect(option.id);
      }
    }
  };

  return (
    <SelectCore
      value={selectedLabel}
      onSelect={handleDesktopSelect}
      disableDeselect
    >
      <StyledSelectInput $active={isActive} />

      <StyledSelectionList>
        {options.map((option) => (
          <SelectOption
            key={option.id ?? 'all'}
            value={getOptionValue(option)}
            label={option.content}
          />
        ))}
      </StyledSelectionList>
    </SelectCore>
  );
};

export default ClassTypeDropdown;
